import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  templateUrl: 'notice.component.html',
  styleUrls: ['notice.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class NoticeComponent {
  constructor(
    private noticeRef: MatSnackBarRef<NoticeComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) { }

  closeNotice() {
    this.noticeRef.dismiss();
  }
}
